import React from 'react';

const AppLoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-surface-page z-[9999]">
      <div className="flex flex-col items-center gap-8">
        <div className="relative w-20 h-20">
          <div
            className="absolute inset-0 rounded-full border-4 border-brand/20 animate-spin"
            style={{ borderTopColor: '#219EBC', animationDuration: '1s' }}
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <img
              src="/quazi-glyph.svg"
              alt="QUAZI"
              className="w-10 h-10 drop-shadow-[0_0_16px_rgba(33,158,188,0.7)] animate-pulse"
            />
          </div>
        </div>

        <div className="flex flex-col items-center gap-1.5">
          <span className="font-display text-sm font-semibold tracking-[3px] uppercase text-content-secondary">
            QUAZI
          </span>
          <span className="text-xs text-content-tertiary tracking-wider">
            Loading your workspace…
          </span>
        </div>
      </div>
    </div>
  );
};

export default AppLoadingScreen;
